import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatStepper, MatDialog } from '@angular/material';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { ReservationPatientRequiredComponent } from '../reservation-patient-required/reservation-patient-required.component';
import { ReservationCTWizardService, ReservationRegularWizardService, ReservationWizardService } from '../../../services/wizard/reservation/reservation.wizard.service';
import { ReservationQuestionComponent } from '../reservation-question/reservation-question.component';
import { ReservationCalendarComponent } from '../reservation-calendar/reservation-calendar.component';
import { ReservationPriceComponent } from '../reservation-price/reservation-price.component';
import { ReservationOrderComponent } from '../reservation-order/reservation-order.component';
import { ReservationPracticeComponent } from '../reservation-practice/reservation-practice.component';
import { ReservationPatientComponent } from '../reservation-patient/reservation-patient.component';
import { WizardStep, Wizard } from '../../../wizard/wizard.component';
import { MenuService } from '../../../services/menu.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { ReservationRescheduleWizardService } from '../../../services/wizard/reservation/reservation-reschedule.wizard.service';
import { MedicalAppointmentWizardCancelDialogComponent } from '../../dialogs/medical-appointment-wizard-cancel/medical-appointment-wizard-cancel-dialog.component';
import { ReservationService } from '../../../services/reservation.service';
import { Reservation } from '../../../model/reservation';

@Component({
  selector: 'app-reservation-ct-wizard-component',
  templateUrl: './reservation-ct-wizard.component.html',
  styleUrls: ['./reservation-ct-wizard.component.css'],
  providers: [{ provide: ReservationWizardService, useClass: ReservationCTWizardService }]
})

export class ReservationCTWizardComponent implements OnInit, AfterViewInit {
 
  reAppointment: boolean;
  returnUrl: string;
  medicalAppointmentId: number;

  constructor(private menuService: MenuService,
    private dialog: MatDialog,
    private notificationToastService: NotificationToastService,
    private reservationRescheduleWizardService: ReservationRescheduleWizardService,
    private router: Router,
    private route: ActivatedRoute, 
    private reservationService: ReservationService,
    private reservationWizardService: ReservationWizardService) {
    this.menuService.setMenuTitle('Reserva', 'asignación Salud Mental');

    this.route.params.subscribe(async (params) => {
      this.reAppointment = params['reAppointment'];
      this.returnUrl = params['returnUrl'];
      this.medicalAppointmentId = params['medicalAppointmentId'];
    });

    if (!this.reservationWizardService.isRescheduling) {
      this.reservationWizardService.reset();
    }

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.reservationWizardService.onCancelWizard.subscribe(() => {
      if (this.reservationWizardService.getAllServiceReservations.length > 0) {
        this.openMedicalAppointmentWizardCancelDialog();
      } else {
        this.router.navigated = false;
        this.reservationWizardService.finalize();
      }
    });
  }

  get isReservationFinished(): boolean { return this.reservationWizardService.reservationFinished; }
 
  get reservationCalendarCompleted() {
    return this.reservationCalendarComponent ? this.reservationCalendarComponent.completed : false;
  }
  get reservationPriceCompleted() {
    return this.reservationPriceComponent ? this.reservationPriceComponent.completed : false;
  }
  get reservationOrderCompleted() {
    return this.reservationOrderComponent ? this.reservationOrderComponent.completed : false;
  }
  get reservationPatientCompleted() {
    return this.reservationPatientComponent ? this.reservationPatientComponent.completed : false;
  }
   
  get reservationPracticeCompleted() {
    return this.reservationPracticeComponent ? this.reservationPracticeComponent.completed : false;
  }
  get isQuestionVisible() {
    return this.reservationWizardService.isQuestionVisible;
  }
  isLinear = false;
  wizard: Wizard = new Wizard();
  loading: boolean;

  
  @ViewChild('reservationCalendarComponent', {static: false}) reservationCalendarComponent: ReservationCalendarComponent;
  @ViewChild('reservationPriceComponent', {static: false}) reservationPriceComponent: ReservationPriceComponent;
  @ViewChild('reservationOrderComponent', {static: false}) reservationOrderComponent: ReservationOrderComponent;
  @ViewChild('reservationPracticeComponent', {static: false}) reservationPracticeComponent: ReservationPracticeComponent;
  @ViewChild('reservationPatientComponent', {static: false}) reservationPatientComponent: ReservationPatientComponent; 
  @ViewChild('stepper', {static: false}) stepper: MatStepper;

  stepIndex = 0;

  steps: WizardStep[] = [];

  openMedicalAppointmentWizardCancelDialog(): void {
        const dialogRef = this.dialog.open(MedicalAppointmentWizardCancelDialogComponent, {
            width: '50%',
            data: this.reservationWizardService.reservation
        });
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
              this.router.navigated = false;
              this.reservationWizardService.finalize();
            }
        });
  }

  ngAfterViewInit() {
     //setTimeout(() => {
     //  this.Init();
     //}, 0);
  }

  private Init() {
    setTimeout(() => {
      this.steps = this.getSteps();
      this.wizard.configure(this.steps, this.stepper);
      this.wizard.initialize();
      // guardo aca porque cuando se toca el wizard desde los botonos de arriba no hace el submit
      this.stepper.selectionChange.subscribe(($event?: StepperSelectionEvent) => {
        const selectedIndex = $event.selectedIndex;
        this.selectStepIndexIfComplete(selectedIndex);
      });
    }, 0);
  }

  private selectStepIndexIfComplete(selectedIndex: number) {
      const isNext = this.stepIndex < selectedIndex;

      if (isNext) {
          this.steps[this.stepIndex].save();
      }

      this.stepIndex = selectedIndex;
      let index = -1;
      let complete = true;
      this.steps = this.getSteps();

      while (complete && index < this.stepIndex - 1) {
          index = index + 1;
          complete = this.steps[index].completed;
      }

      if (!complete) {
          this.stepIndex = index;
      } else {
          if (this.steps[this.stepIndex].isInit) {
              this.steps[this.stepIndex].activate();
          }
      }
  }

  private getSteps() {
    const steps: WizardStep[] = [];
    // se tienen que agregar los pasos en el mismo orden que aparecen
    if (this.reservationPatientComponent) {
      steps.push(this.reservationPatientComponent);
    }
    if (this.reservationPracticeComponent) {
      steps.push(this.reservationPracticeComponent);
    }
    if (this.reservationPriceComponent) {
      steps.push(this.reservationPriceComponent);
    }
    if (this.reservationCalendarComponent) {
      steps.push(this.reservationCalendarComponent);
    }
   
    if (this.reservationOrderComponent) {
      steps.push(this.reservationOrderComponent);
    }

    return steps;
  }

  async ngOnInit() {
    this.loading = true;
    if (!this.reAppointment) {
      this.initReschedulerIfRequired();
    } else {
      await this.initReAppointment();
    }
  }

  private async initReAppointment() {
    try {
      const reservation = await this.reservationService
        .getReservation(this.medicalAppointmentId);
      this.reservationWizardService
        .reAppointment(new Reservation(reservation), this.returnUrl);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Recitación de turno');
    } finally {
      this.loading = false;
      this.Init();
    }
  }

  private initReschedulerIfRequired() {
    const reservationToReschedule = this.reservationRescheduleWizardService
      .getReservation();
    const returnUrl = this.reservationRescheduleWizardService.returnUrl;
    this.reservationRescheduleWizardService.clear();
    if (reservationToReschedule) {
      try {
        this.reservationWizardService.rescheduleDos(reservationToReschedule, returnUrl);
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Reprogramación de turno');
      } finally {
        this.loading = false;
        this.Init();
      }
    } else {
      this.loading = false;
      this.Init();
    }
  }
}
